export const HOME = "/";
export const DATA_HOME = "/";
